<script setup lang="ts">
import type { ContentBlockData } from '~/utils/crystallize/pieces'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  data: ContentBlockData
}>()
</script>

<template>
  <ContentGrid is="section">
    <div class="full-width py-l md:py-40 px-m md:px-3xl bg-blurple-50 rounded-4xl flex gap-2xl items-center">
      <IllustrationJudge class="h-full hidden lg:block min-w-[300px] w-[300px]" />

      <div class="flex flex-col gap-m">
        <h2 v-if="data.title" class="title-xl" v-text="data.title" />
        <p v-if="data.subtitle" class="title-m" v-text="data.subtitle" />

        <CrystallizeRichText
          v-for="(block, i) in data.text"
          :key="i"
          :block="block"
        />

        <div class="flex gap-s md:gap-m items-center flex-wrap">
          <ResponsiveButton variant="primary" color="moss" :to="{ name: 'product-catalogue' }">
            Se&nbsp;våre&nbsp;produkter
          </ResponsiveButton>
          <Button :to="{ name: 'info-page', params: { slug: 'kontakt-salgsavdelingen' } }" variant="secondary" color="carbon" class="h-fit">
            Kontakt&nbsp;oss for&nbsp;tilbud
            <Icon :icon="faArrowRight" />
          </Button>
        </div>
      </div>
    </div>
  </ContentGrid>
</template>
